import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { User } from '@sb-shared/models/user';

@Directive({
    selector: 'ng1-profile-diary',
    standalone: false
})
export class ProfileDiaryUpgrade extends UpgradeComponent {
  @Input() selectedPerson: User;
  constructor(elementRef: ElementRef, injector: Injector) {
    super('ng1ProfileDiary', elementRef, injector);
  }
}
